/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
import type { ExportColumn } from './export-column.js';
import type { ExportTable } from './export-table.js';

// `select` is DimeDataTable's checkbox column and `actions` is by convention the row menu.
const NON_DATA_COLUMN_IDS = new Set(['select', 'actions']);

/** Per visible column: meta.exportValue, else the accessor; a column with neither is omitted. */
export function resolveExportColumns<TData>(table: ExportTable<TData>): ExportColumn<TData>[] {
  const resolved: ExportColumn<TData>[] = [];

  for (const column of table.getVisibleLeafColumns()) {
    if (NON_DATA_COLUMN_IDS.has(column.id)) continue;

    // DimeColumnMeta declares exportValue as `(row: never)`, so it is re-typed once here.
    const exportValue = column.columnDef.meta?.exportValue as
      ((row: TData) => string | number | null) | undefined;
    const { accessorFn } = column;
    if (!exportValue && !accessorFn) continue;

    resolved.push({
      id: column.id,
      label: column.columnDef.meta?.label ?? column.id,
      exportType: column.columnDef.meta?.exportType,
      getValue: exportValue ? (row) => exportValue(row) : (row, index) => accessorFn!(row, index),
    });
  }

  return resolved;
}
